export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5493.ba7b68bc.jpg";